// Source: This data was taken from the monolith database, table zocdoc.dbo.Specialty
import { INSURANCE_TYPES } from './';

/**
 * @deprecated use @zocdoc-frontend-common/utils-constants instead
 * @type {Object.<string, string>}
 */
export const SPECIALTY_IDS = {
    DENTIST: '98',
    INTERNIST: '99',
    PEDIATRICIAN: '100',
    DERMATOLOGIST: '101',
    FAMILY_PHYSICIAN: '102',
    OB_GYN: '104',
    CARDIOLOGIST: '105',
    GASTROENTEROLOGIST: '106',
    NEPHROLOGIST: '107',
    PULMONOLOGIST: '108',
    RHEUMATOLOGIST: '109',
    HEMATOLOGIST: '110',
    ONCOLOGIST: '111',
    CARDIAC_ELECTROPHYSIOLOGIST: '112',
    NEUROSURGEON: '113',
    INFECTIOUS_DISEASE_SPECIALIST: '114',
    NUCLEAR_MEDICINE_SPECIALIST: '115',
    OPHTHALMOLOGIST: '116',
    ORTHOPEDIC_SURGEON: '117',
    PATHOLOGIST: '118',
    PLASTIC_SURGEON: '120',
    PODIATRIST: '121',
    PSYCHIATRIST: '122',
    RADIOLOGIST: '123',
    RADIATION_ONCOLOGIST: '124',
    UROLOGIST: '126',
    ENDOCRINOLOGIST: '127',
    NEUROLOGIST: '128',
    SPORTS_MEDICINE_SPECIALIST: '129',
    EAR_NOSE_AND_THROAT_DOCTOR: '130',
    ALLERGIST: '132',
    COLORECTAL_SURGEON: '133',
    ENDODONTIST: '134',
    ORTHODONTIST: '135',
    PERIODONTIST: '136',
    PROSTHODONTIST: '137',
    PAIN_MANAGEMENT_SPECIALIST: '139',
    PEDIATRIC_SURGEON: '141',
    VASCULAR_SURGEON: '142',
    CARDIOTHORACIC_SURGEON: '143',
    HAND_SURGEON: '144',
    ANESTHESIOLOGIST: '145',
    EMERGENCY_MEDICINE_PHYSICIAN: '146',
    GENETICIST: '148',
    ORAL_SURGEON: '151',
    PEDIATRIC_DENTIST: '152',
    PRIMARY_CARE_PHYSICIAN: '153',
    IMMUNOLOGIST: '154',
    SLEEP_MEDICINE_SPECIALIST: '155',
    CHIROPRACTOR: '156',
    OPTOMETRIST: '157',
    SURGEON: '158',
    MICROBIOLOGIST: '159',
    AESTHETIC_SURGEON: '160',
    CRANIOFACIAL_SURGEON: '161',
    HEAD_AND_NECK_SURGEON: '164',
    MICROVASCULAR_SURGEON: '165',
    FACIAL_PLASTIC_AND_RECONSTRUCTIVE_SURGEON: '167',
    NEURO_OTOLOGIST: '169',
    SINUS_SURGEON_RHINOLOGIST: '170',
    PEDIATRIC_OTOLARYNGOLOGIST: '171',
    GERIATRICIAN: '173',
    OCULAR_ONCOLOGIST: '176',
    OCULAR_PATHOLOGIST: '177',
    OPHTHALMIC_PLASTIC_ORBITAL_AND_RECONSTRUCTIVE_SURGEON: '178',
    OPHTHALMIC_PATHOLOGIST: '179',
    NEURO_OPHTHALMOLOGIST: '180',
    RETINA_SPECIALIST_MEDICAL: '181',
    RETINA_AND_VITREOUS_SURGEON: '182',
    CORNEA_AND_EXTERNAL_DISEASES_SPECIALIST: '183',
    PEDIATRIC_STRABISMUS_EYE_DOCTOR: '184',
    OCULOPLASTIC_SURGEON: '186',
    PEDIATRIC_ANESTHESIOLOGIST: '193',
    NEURO_RADIOLOGIST: '194',
    LARYNGOLOGIST: '197',
    GLAUCOMA_SPECIALIST: '212',
    UVEITIS_SPECIALIST: '213',
    REFRACTIVE_SURGEON: '221',
    MATERNAL_FETAL_MEDICINE_SPECIALIST: '234',
    GYNECOLOGIC_ONCOLOGIST: '235',
    UROGYNECOLOGIST: '237',
    BEHAVIORAL_PEDIATRICS_SPECIALIST: '239',
    PEDIATRIC_CARDIOLOGIST: '240',
    PEDIATRIC_CRITICAL_CARE_SPECIALIST: '241',
    PEDIATRIC_ENDOCRINOLOGIST: '242',
    PEDIATRIC_GASTROENTEROLOGIST: '243',
    PEDIATRIC_HEMATOLOGIST: '244',
    PEDIATRIC_ONCOLOGIST: '245',
    PEDIATRIC_INFECTIOUS_DISEASE_SPECIALIST: '246',
    PEDIATRIC_NEPHROLOGIST: '247',
    PEDIATRIC_PULMONOLOGIST: '248',
    CHILD_AND_ADOLESCENT_PSYCHIATRIST: '250',
    NEONATAL_PERINATAL_MEDICINE_SPECIALIST: '252',
    ADOLESCENT_MEDICINE_SPECIALIST: '253',
    BREAST_SURGEON: '255',
    BARIATRIC_SURGEON: '256',
    TRAUMA_SURGEON: '258',
    PEDIATRIC_NEUROLOGIST: '261',
    ULTRASOUND_SONOGRAPHY_SPECIALIST: '264',
    PEDIATRIC_RADIOLOGIST: '265',
    INTERVENTIONAL_RADIOLOGIST: '268',
    ABDOMINAL_RADIOLOGIST: '271',
    RECONSTRUCTIVE_SURGEON: '272',
    CARDIOTHORACIC_RADIOLOGIST: '273',
    CHEMICAL_PATHOLOGY_SPECIALIST: '274',
    CLINICAL_NEUROPHYSIOLOGIST: '275',
    SKIN_PATHOLOGY_SPECIALIST_DERMATOPATHOLOGY: '276',
    INTERVENTIONAL_NEURO_RADIOLOGIST: '277',
    CRITICAL_CARE_SPECIALIST: '278',
    FOOT_AND_ANKLE_SPECIALIST: '279',
    FORENSIC_PSYCHIATRIST: '280',
    GERIATRIC_PSYCHIATRIST: '281',
    MEDICAL_BIOCHEMICAL_GENETICIST: '283',
    MOLECULAR_GENETIC_PATHOLOGIST: '284',
    MUSCULOSKELETAL_RADIOLOGIST: '286',
    NEUROMUSCULAR_SPECIALIST: '287',
    NEUROPATHOLOGIST: '288',
    SPINE_SPECIALIST: '290',
    PEDIATRIC_SPORTS_MEDICINE_SPECIALIST: '296',
    PROCEDURAL_DERMATOLOGY_SPECIALIST: '297',
    ADDICTION_SPECIALIST: '298',
    PSYCHOSOMATIC_MEDICINE_SPECIALIST: '299',
    TRANSFUSION_MEDICINE_SPECIALIST_BLOOD_BANK: '300',
    CYTOPATHOLOGIST: '301',
    FORENSIC_PATHOLOGIST: '302',
    PEDIATRIC_PATHOLOGIST: '304',
    PEDIATRIC_ORTHOPEDIC_SURGEON: '309',
    CARDIOTHORACIC_ANESTHESIOLOGIST: '310',
    DEVELOPMENTAL_PEDIATRICS_SPECIALIST: '311',
    PEDIATRIC_UROLOGIST: '312',
    MUSCOLOSKELETAL_ONCOLOGIST: '315',
    NEURODEVELOPMENTAL_DISABILITIES_SPECIALIST: '318',
    VASCULAR_NEUROLOGY_SPECIALIST: '319',
    PEDIATRIC_REHABILITATION_SPECIALIST: '320',
    TOXICOLOGIST: '322',
    HYPERBARIC_TREATMENT_SPECIALIST: '324',
    TRANSPLANT_SPECIALIST: '326',
    PEDIATRIC_TRANSPLANT_SPECIALIST: '327',
    COSMETIC_DENTIST: '333',
    DENTAL_PAIN_SPECIALIST: '334',
    PHYSICAL_THERAPIST: '335',
    PHYSIATRIST: '336',
    PSYCHOLOGIST: '337',
    PEDIATRIC_DERMATOLOGIST: '338',
    REPRODUCTIVE_ENDOCRINOLOGIST: '339',
    PEDIATRIC_NEUROSURGEON: '341',
    TRAVEL_MEDICINE_SPECIALIST: '343',
    PREVENTIVE_MEDICINE_SPECIALIST: '344',
    ACUPUNCTURIST: '345',
    AUDIOLOGIST: '346',
    PEDIATRIC_ALLERGIST: '347',
    PEDIATRIC_RHEUMATOLOGIST: '351',
    PSYCHOTHERAPIST: '352',
    SHOULDER_AND_ELBOW_SURGEON: '353',
    MEDICAL_ETHICIST: '354',
    INTERVENTIONAL_CARDIOLOGIST: '355',
    OCCUPATIONAL_MEDICINE_SPECIALIST: '357',
    DIETITIAN: '359',
    HEPATOLOGIST: '360',
    MIDWIFE: '362',
    HIP_AND_KNEE_SURGEON: '363',
    BARIATRIC_PHYSICIAN: '364',
    PROCTOLOGIST: '366',
    COSMETIC_DERMATOLOGIST: '367',
    GYNECOLOGIST: '368',
    HEART_FAILURE_HEART_TRANSPLANT_SPECIALIST: '369',
    HOSPICE_AND_PALLIATIVE_MEDICINE_SPECIALIST: '370',
    MASSAGE_THERAPIST: '371',
    MAXILLOFACIAL_PROSTHODONTIST: '372',
    NATUROPATHIC_DOCTOR: '373',
    OCCUPATIONAL_THERAPIST: '374',
    OPTOMETRIC_GLAUCOMA_SPECIALIST: '376',
    ORTHOPEDIC_ONCOLOGIST: '377',
    OSTEOPATHIC_DOCTOR: '378',
    PEDIATRIC_CARDIOTHORACIC_SURGEON: '379',
    PEDIATRIC_PAIN_MANAGEMENT_SPECIALIST: '380',
    PHYSICIAN_ASSISTANT: '381',
    URGENT_CARE_SPECIALIST: '382',
    NEUROPSYCHIATRIST: '383',
    NUTRITIONIST: '384',
    EYE_DOCTOR: '386',
    SURGICAL_ONCOLOGIST: '390',
    NURSE_PRACTITIONER: '399',
    ADULT_NURSE_PRACTITIONER: '400',
    FAMILY_NURSE_PRACTITIONER: '401',
    PEDIATRIC_NURSE_PRACTITIONER: '402',
    WOMENS_HEALTH_NURSE_PRACTITIONER: '403',
    OB_GYN_NURSE_PRACTITIONER: '404',
    ADULT_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER: '405',
    FAMILY_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER: '406',
    MENTAL_HEALTH_NURSE_PRACTITIONER: '407',
    UROLOGICAL_SURGEON: '408',
    OTOLOGIST: '410',
    FOOT_SURGEON: '411',
    HIP_SURGEON: '412',
    KNEE_SURGEON: '413',
    ELBOW_SURGEON: '414',
    SHOULDER_SURGEON: '415',
    CHILD_AND_ADOLESCENT_PSYCHOLOGIST: '416',
    ENDOCRINE_SURGEON: '419',
    INTEGRATIVE_HEALTH_MEDICINE_SPECIALIST: '420',
    BURN_SURGEON: '421',
    ADVANCED_HEART_FAILURE_AND_TRANSPLANT_CARDIOLOGIST: '422',
    PEDIATRIC_SLEEP_MEDICINE_SPECIALIST: '423',
    HOSPITALIST: '476',
};

/**
 * @deprecated use @zocdoc-frontend-common/utils-constants instead
 * @type {Object.<string, string>}
 */
export const SPECIALTY_NAMES = {
    [SPECIALTY_IDS.DENTIST]: 'Dentist',
    [SPECIALTY_IDS.INTERNIST]: 'Internist',
    [SPECIALTY_IDS.PEDIATRICIAN]: 'Pediatrician',
    [SPECIALTY_IDS.DERMATOLOGIST]: 'Dermatologist',
    [SPECIALTY_IDS.FAMILY_PHYSICIAN]: 'Family Physician',
    [SPECIALTY_IDS.OB_GYN]: 'OB-GYN',
    [SPECIALTY_IDS.CARDIOLOGIST]: 'Cardiologist',
    [SPECIALTY_IDS.GASTROENTEROLOGIST]: 'Gastroenterologist',
    [SPECIALTY_IDS.NEPHROLOGIST]: 'Nephrologist',
    [SPECIALTY_IDS.PULMONOLOGIST]: 'Pulmonologist',
    [SPECIALTY_IDS.RHEUMATOLOGIST]: 'Rheumatologist',
    [SPECIALTY_IDS.HEMATOLOGIST]: 'Hematologist',
    [SPECIALTY_IDS.ONCOLOGIST]: 'Oncologist',
    [SPECIALTY_IDS.CARDIAC_ELECTROPHYSIOLOGIST]: 'Cardiac Electrophysiologist',
    [SPECIALTY_IDS.NEUROSURGEON]: 'Neurosurgeon',
    [SPECIALTY_IDS.INFECTIOUS_DISEASE_SPECIALIST]:
        'Infectious Disease Specialist',
    [SPECIALTY_IDS.NUCLEAR_MEDICINE_SPECIALIST]: 'Nuclear Medicine Specialist',
    [SPECIALTY_IDS.OPHTHALMOLOGIST]: 'Ophthalmologist',
    [SPECIALTY_IDS.ORTHOPEDIC_SURGEON]: 'Orthopedic Surgeon',
    [SPECIALTY_IDS.PATHOLOGIST]: 'Pathologist',
    [SPECIALTY_IDS.PLASTIC_SURGEON]: 'Plastic Surgeon',
    [SPECIALTY_IDS.PODIATRIST]: 'Podiatrist',
    [SPECIALTY_IDS.PSYCHIATRIST]: 'Psychiatrist',
    [SPECIALTY_IDS.RADIOLOGIST]: 'Radiologist',
    [SPECIALTY_IDS.RADIATION_ONCOLOGIST]: 'Radiation Oncologist',
    [SPECIALTY_IDS.UROLOGIST]: 'Urologist',
    [SPECIALTY_IDS.ENDOCRINOLOGIST]: 'Endocrinologist',
    [SPECIALTY_IDS.NEUROLOGIST]: 'Neurologist',
    [SPECIALTY_IDS.SPORTS_MEDICINE_SPECIALIST]: 'Sports Medicine Specialist',
    [SPECIALTY_IDS.EAR_NOSE_AND_THROAT_DOCTOR]: 'Ear, Nose & Throat Doctor',
    [SPECIALTY_IDS.ALLERGIST]: 'Allergist',
    [SPECIALTY_IDS.COLORECTAL_SURGEON]: 'Colorectal Surgeon',
    [SPECIALTY_IDS.ENDODONTIST]: 'Endodontist',
    [SPECIALTY_IDS.ORTHODONTIST]: 'Orthodontist',
    [SPECIALTY_IDS.PERIODONTIST]: 'Periodontist',
    [SPECIALTY_IDS.PROSTHODONTIST]: 'Prosthodontist',
    [SPECIALTY_IDS.PAIN_MANAGEMENT_SPECIALIST]: 'Pain Management Specialist',
    [SPECIALTY_IDS.PEDIATRIC_SURGEON]: 'Pediatric Surgeon',
    [SPECIALTY_IDS.VASCULAR_SURGEON]: 'Vascular Surgeon',
    [SPECIALTY_IDS.CARDIOTHORACIC_SURGEON]: 'Cardiothoracic Surgeon',
    [SPECIALTY_IDS.HAND_SURGEON]: 'Hand Surgeon',
    [SPECIALTY_IDS.ANESTHESIOLOGIST]: 'Anesthesiologist',
    [SPECIALTY_IDS.EMERGENCY_MEDICINE_PHYSICIAN]:
        'Emergency Medicine Physician',
    [SPECIALTY_IDS.GENETICIST]: 'Geneticist',
    [SPECIALTY_IDS.ORAL_SURGEON]: 'Oral Surgeon',
    [SPECIALTY_IDS.PEDIATRIC_DENTIST]: 'Pediatric Dentist',
    [SPECIALTY_IDS.PRIMARY_CARE_PHYSICIAN]: 'Primary Care Doctor',
    [SPECIALTY_IDS.IMMUNOLOGIST]: 'Immunologist',
    [SPECIALTY_IDS.SLEEP_MEDICINE_SPECIALIST]: 'Sleep Medicine Specialist',
    [SPECIALTY_IDS.CHIROPRACTOR]: 'Chiropractor',
    [SPECIALTY_IDS.OPTOMETRIST]: 'Optometrist',
    [SPECIALTY_IDS.SURGEON]: 'Surgeon',
    [SPECIALTY_IDS.MICROBIOLOGIST]: 'Microbiologist',
    [SPECIALTY_IDS.AESTHETIC_SURGEON]: 'Aesthetic Surgeon',
    [SPECIALTY_IDS.CRANIOFACIAL_SURGEON]: 'Craniofacial Surgeon',
    [SPECIALTY_IDS.HEAD_AND_NECK_SURGEON]: 'Head & Neck Surgeon',
    [SPECIALTY_IDS.MICROVASCULAR_SURGEON]: 'Microvascular Surgeon',
    [SPECIALTY_IDS.FACIAL_PLASTIC_AND_RECONSTRUCTIVE_SURGEON]:
        'Facial Plastic & Reconstructive Surgeon',
    [SPECIALTY_IDS.NEURO_OTOLOGIST]: 'Neuro-Otologist',
    [SPECIALTY_IDS.SINUS_SURGEON_RHINOLOGIST]: 'Sinus Surgeon / Rhinologist',
    [SPECIALTY_IDS.PEDIATRIC_OTOLARYNGOLOGIST]: 'Pediatric Otolaryngologist',
    [SPECIALTY_IDS.GERIATRICIAN]: 'Geriatrician',
    [SPECIALTY_IDS.OCULAR_ONCOLOGIST]: 'Ocular Oncologist',
    [SPECIALTY_IDS.OCULAR_PATHOLOGIST]: 'Ocular Pathologist',
    [SPECIALTY_IDS.OPHTHALMIC_PLASTIC_ORBITAL_AND_RECONSTRUCTIVE_SURGEON]:
        'Ophthalmic Plastic, Orbital & Reconstructive Surgeon',
    [SPECIALTY_IDS.OPHTHALMIC_PATHOLOGIST]: 'Ophthalmic Pathologist',
    [SPECIALTY_IDS.NEURO_OPHTHALMOLOGIST]: 'Neuro-Ophthalmologist',
    [SPECIALTY_IDS.RETINA_SPECIALIST_MEDICAL]: 'Retina Specialist (Medical)',
    [SPECIALTY_IDS.RETINA_AND_VITREOUS_SURGEON]: 'Retina & Vitreous Surgeon',
    [SPECIALTY_IDS.CORNEA_AND_EXTERNAL_DISEASES_SPECIALIST]:
        'Cornea & External Diseases Specialist',
    [SPECIALTY_IDS.PEDIATRIC_STRABISMUS_EYE_DOCTOR]:
        'Pediatric / Strabismus Eye Doctor',
    [SPECIALTY_IDS.OCULOPLASTIC_SURGEON]: 'Oculoplastic Surgeon',
    [SPECIALTY_IDS.PEDIATRIC_ANESTHESIOLOGIST]: 'Pediatric Anesthesiologist',
    [SPECIALTY_IDS.NEURO_RADIOLOGIST]: 'Neuro-Radiologist',
    [SPECIALTY_IDS.LARYNGOLOGIST]: 'Laryngologist',
    [SPECIALTY_IDS.GLAUCOMA_SPECIALIST]: 'Glaucoma Specialist',
    [SPECIALTY_IDS.UVEITIS_SPECIALIST]: 'Uveitis Specialist',
    [SPECIALTY_IDS.REFRACTIVE_SURGEON]: 'Refractive Surgeon',
    [SPECIALTY_IDS.MATERNAL_FETAL_MEDICINE_SPECIALIST]:
        'Maternal Fetal Medicine Specialist',
    [SPECIALTY_IDS.GYNECOLOGIC_ONCOLOGIST]: 'Gynecologic Oncologist',
    [SPECIALTY_IDS.UROGYNECOLOGIST]: 'Urogynecologist',
    [SPECIALTY_IDS.BEHAVIORAL_PEDIATRICS_SPECIALIST]:
        'Behavioral Pediatrics Specialist',
    [SPECIALTY_IDS.PEDIATRIC_CARDIOLOGIST]: 'Pediatric Cardiologist',
    [SPECIALTY_IDS.PEDIATRIC_CRITICAL_CARE_SPECIALIST]:
        'Pediatric Critical Care Specialist',
    [SPECIALTY_IDS.PEDIATRIC_ENDOCRINOLOGIST]: 'Pediatric Endocrinologist',
    [SPECIALTY_IDS.PEDIATRIC_GASTROENTEROLOGIST]:
        'Pediatric Gastroenterologist',
    [SPECIALTY_IDS.PEDIATRIC_HEMATOLOGIST]: 'Pediatric Hematologist',
    [SPECIALTY_IDS.PEDIATRIC_ONCOLOGIST]: 'Pediatric Oncologist',
    [SPECIALTY_IDS.PEDIATRIC_INFECTIOUS_DISEASE_SPECIALIST]:
        'Pediatric Infectious Disease Specialist',
    [SPECIALTY_IDS.PEDIATRIC_NEPHROLOGIST]: 'Pediatric Nephrologist',
    [SPECIALTY_IDS.PEDIATRIC_PULMONOLOGIST]: 'Pediatric Pulmonologist',
    [SPECIALTY_IDS.CHILD_AND_ADOLESCENT_PSYCHIATRIST]:
        'Child and Adolescent Psychiatrist',
    [SPECIALTY_IDS.NEONATAL_PERINATAL_MEDICINE_SPECIALIST]:
        'Neonatal-Perinatal Medicine Specialist',
    [SPECIALTY_IDS.ADOLESCENT_MEDICINE_SPECIALIST]:
        'Adolescent Medicine Specialist',
    [SPECIALTY_IDS.BREAST_SURGEON]: 'Breast Surgeon',
    [SPECIALTY_IDS.BARIATRIC_SURGEON]: 'Bariatric Surgeon',
    [SPECIALTY_IDS.TRAUMA_SURGEON]: 'Trauma Surgeon',
    [SPECIALTY_IDS.PEDIATRIC_NEUROLOGIST]: 'Pediatric Neurologist',
    [SPECIALTY_IDS.ULTRASOUND_SONOGRAPHY_SPECIALIST]:
        'Ultrasound / Sonography Specialist',
    [SPECIALTY_IDS.PEDIATRIC_RADIOLOGIST]: 'Pediatric Radiologist',
    [SPECIALTY_IDS.INTERVENTIONAL_RADIOLOGIST]: 'Interventional Radiologist',
    [SPECIALTY_IDS.ABDOMINAL_RADIOLOGIST]: 'Abdominal Radiologist',
    [SPECIALTY_IDS.RECONSTRUCTIVE_SURGEON]: 'Reconstructive Surgeon',
    [SPECIALTY_IDS.CARDIOTHORACIC_RADIOLOGIST]: 'Cardiothoracic Radiologist',
    [SPECIALTY_IDS.CHEMICAL_PATHOLOGY_SPECIALIST]:
        'Chemical Pathology Specialist',
    [SPECIALTY_IDS.CLINICAL_NEUROPHYSIOLOGIST]: 'Clinical Neurophysiologist',
    [SPECIALTY_IDS.SKIN_PATHOLOGY_SPECIALIST_DERMATOPATHOLOGY]:
        'Skin Pathology Specialist (Dermatopathology)',
    [SPECIALTY_IDS.INTERVENTIONAL_NEURO_RADIOLOGIST]:
        'Interventional Neuro-Radiologist',
    [SPECIALTY_IDS.CRITICAL_CARE_SPECIALIST]: 'Critical Care Specialist',
    [SPECIALTY_IDS.FOOT_AND_ANKLE_SPECIALIST]: 'Foot & Ankle Specialist',
    [SPECIALTY_IDS.FORENSIC_PSYCHIATRIST]: 'Forensic Psychiatrist',
    [SPECIALTY_IDS.GERIATRIC_PSYCHIATRIST]: 'Geriatric Psychiatrist',
    [SPECIALTY_IDS.MEDICAL_BIOCHEMICAL_GENETICIST]:
        'Medical Biochemical Geneticist',
    [SPECIALTY_IDS.MOLECULAR_GENETIC_PATHOLOGIST]:
        'Molecular Genetic Pathologist',
    [SPECIALTY_IDS.MUSCULOSKELETAL_RADIOLOGIST]: 'Musculoskeletal Radiologist',
    [SPECIALTY_IDS.NEUROMUSCULAR_SPECIALIST]: 'Neuromuscular Specialist',
    [SPECIALTY_IDS.NEUROPATHOLOGIST]: 'Neuropathologist',
    [SPECIALTY_IDS.SPINE_SPECIALIST]: 'Spine Specialist',
    [SPECIALTY_IDS.PEDIATRIC_SPORTS_MEDICINE_SPECIALIST]:
        'Pediatric Sports Medicine Specialist',
    [SPECIALTY_IDS.PROCEDURAL_DERMATOLOGY_SPECIALIST]:
        'Procedural Dermatology Specialist',
    [SPECIALTY_IDS.ADDICTION_SPECIALIST]: 'Addiction Specialist',
    [SPECIALTY_IDS.PSYCHOSOMATIC_MEDICINE_SPECIALIST]:
        'Psychosomatic Medicine Specialist',
    [SPECIALTY_IDS.TRANSFUSION_MEDICINE_SPECIALIST_BLOOD_BANK]:
        'Transfusion Medicine Specialist (Blood Bank)',
    [SPECIALTY_IDS.CYTOPATHOLOGIST]: 'Cytopathologist',
    [SPECIALTY_IDS.FORENSIC_PATHOLOGIST]: 'Forensic Pathologist',
    [SPECIALTY_IDS.PEDIATRIC_PATHOLOGIST]: 'Pediatric Pathologist',
    [SPECIALTY_IDS.PEDIATRIC_ORTHOPEDIC_SURGEON]:
        'Pediatric Orthopedic Surgeon',
    [SPECIALTY_IDS.CARDIOTHORACIC_ANESTHESIOLOGIST]:
        'Cardiothoracic Anesthesiologist',
    [SPECIALTY_IDS.DEVELOPMENTAL_PEDIATRICS_SPECIALIST]:
        'Developmental Pediatrics Specialist',
    [SPECIALTY_IDS.PEDIATRIC_UROLOGIST]: 'Pediatric Urologist',
    [SPECIALTY_IDS.MUSCOLOSKELETAL_ONCOLOGIST]: 'Muscoloskeletal Oncologist',
    [SPECIALTY_IDS.NEURODEVELOPMENTAL_DISABILITIES_SPECIALIST]:
        'Neurodevelopmental Disabilities Specialist',
    [SPECIALTY_IDS.VASCULAR_NEUROLOGY_SPECIALIST]:
        'Vascular Neurology Specialist',
    [SPECIALTY_IDS.PEDIATRIC_REHABILITATION_SPECIALIST]:
        'Pediatric Rehabilitation Specialist',
    [SPECIALTY_IDS.TOXICOLOGIST]: 'Toxicologist',
    [SPECIALTY_IDS.HYPERBARIC_TREATMENT_SPECIALIST]:
        'Hyperbaric Treatment Specialist',
    [SPECIALTY_IDS.TRANSPLANT_SPECIALIST]: 'Transplant Specialist',
    [SPECIALTY_IDS.PEDIATRIC_TRANSPLANT_SPECIALIST]:
        'Pediatric Transplant Specialist',
    [SPECIALTY_IDS.COSMETIC_DENTIST]: 'Cosmetic Dentist',
    [SPECIALTY_IDS.DENTAL_PAIN_SPECIALIST]: 'Dental Pain Specialist',
    [SPECIALTY_IDS.PHYSICAL_THERAPIST]: 'Physical Therapist',
    [SPECIALTY_IDS.PHYSIATRIST]: 'Physiatrist',
    [SPECIALTY_IDS.PSYCHOLOGIST]: 'Psychologist',
    [SPECIALTY_IDS.PEDIATRIC_DERMATOLOGIST]: 'Pediatric Dermatologist',
    [SPECIALTY_IDS.REPRODUCTIVE_ENDOCRINOLOGIST]:
        'Reproductive Endocrinologist',
    [SPECIALTY_IDS.PEDIATRIC_NEUROSURGEON]: 'Pediatric Neurosurgeon',
    [SPECIALTY_IDS.TRAVEL_MEDICINE_SPECIALIST]: 'Travel Medicine Specialist',
    [SPECIALTY_IDS.PREVENTIVE_MEDICINE_SPECIALIST]:
        'Preventive Medicine Specialist',
    [SPECIALTY_IDS.ACUPUNCTURIST]: 'Acupuncturist',
    [SPECIALTY_IDS.AUDIOLOGIST]: 'Audiologist',
    [SPECIALTY_IDS.PEDIATRIC_ALLERGIST]: 'Pediatric Allergist',
    [SPECIALTY_IDS.PEDIATRIC_RHEUMATOLOGIST]: 'Pediatric Rheumatologist',
    [SPECIALTY_IDS.PSYCHOTHERAPIST]: 'Psychotherapist',
    [SPECIALTY_IDS.SHOULDER_AND_ELBOW_SURGEON]: 'Shoulder & Elbow Surgeon',
    [SPECIALTY_IDS.MEDICAL_ETHICIST]: 'Medical Ethicist',
    [SPECIALTY_IDS.INTERVENTIONAL_CARDIOLOGIST]: 'Interventional Cardiologist',
    [SPECIALTY_IDS.OCCUPATIONAL_MEDICINE_SPECIALIST]:
        'Occupational Medicine Specialist',
    [SPECIALTY_IDS.DIETITIAN]: 'Dietitian',
    [SPECIALTY_IDS.HEPATOLOGIST]: 'Hepatologist ',
    [SPECIALTY_IDS.MIDWIFE]: 'Midwife',
    [SPECIALTY_IDS.HIP_AND_KNEE_SURGEON]: 'Hip and Knee Surgeon',
    [SPECIALTY_IDS.BARIATRIC_PHYSICIAN]: 'Bariatric Physician',
    [SPECIALTY_IDS.PROCTOLOGIST]: 'Proctologist',
    [SPECIALTY_IDS.COSMETIC_DERMATOLOGIST]: 'Cosmetic Dermatologist',
    [SPECIALTY_IDS.GYNECOLOGIST]: 'Gynecologist',
    [SPECIALTY_IDS.HEART_FAILURE_HEART_TRANSPLANT_SPECIALIST]:
        'Heart Failure / Heart Transplant Specialist',
    [SPECIALTY_IDS.HOSPICE_AND_PALLIATIVE_MEDICINE_SPECIALIST]:
        'Hospice and Palliative Medicine Specialist',
    [SPECIALTY_IDS.MASSAGE_THERAPIST]: 'Massage Therapist',
    [SPECIALTY_IDS.MAXILLOFACIAL_PROSTHODONTIST]:
        'Maxillofacial Prosthodontist',
    [SPECIALTY_IDS.NATUROPATHIC_DOCTOR]: 'Naturopathic Doctor',
    [SPECIALTY_IDS.OCCUPATIONAL_THERAPIST]: 'Occupational Therapist',
    [SPECIALTY_IDS.OPTOMETRIC_GLAUCOMA_SPECIALIST]:
        'Optometric Glaucoma Specialist',
    [SPECIALTY_IDS.ORTHOPEDIC_ONCOLOGIST]: 'Orthopedic Oncologist',
    [SPECIALTY_IDS.OSTEOPATHIC_DOCTOR]: 'Osteopathic Doctor',
    [SPECIALTY_IDS.PEDIATRIC_CARDIOTHORACIC_SURGEON]:
        'Pediatric Cardiothoracic Surgeon',
    [SPECIALTY_IDS.PEDIATRIC_PAIN_MANAGEMENT_SPECIALIST]:
        'Pediatric Pain Management Specialist',
    [SPECIALTY_IDS.PHYSICIAN_ASSISTANT]: 'Physician Assistant',
    [SPECIALTY_IDS.URGENT_CARE_SPECIALIST]: 'Urgent Care Specialist',
    [SPECIALTY_IDS.NEUROPSYCHIATRIST]: 'Neuropsychiatrist',
    [SPECIALTY_IDS.NUTRITIONIST]: 'Nutritionist',
    [SPECIALTY_IDS.EYE_DOCTOR]: 'Eye Doctor',
    [SPECIALTY_IDS.SURGICAL_ONCOLOGIST]: 'Surgical Oncologist',
    [SPECIALTY_IDS.NURSE_PRACTITIONER]: 'Nurse Practitioner',
    [SPECIALTY_IDS.ADULT_NURSE_PRACTITIONER]: 'Adult Nurse Practitioner',
    [SPECIALTY_IDS.FAMILY_NURSE_PRACTITIONER]: 'Family Nurse Practitioner',
    [SPECIALTY_IDS.PEDIATRIC_NURSE_PRACTITIONER]:
        'Pediatric Nurse Practitioner',
    [SPECIALTY_IDS.WOMENS_HEALTH_NURSE_PRACTITIONER]:
        "Women's Health Nurse Practitioner",
    [SPECIALTY_IDS.OB_GYN_NURSE_PRACTITIONER]: 'OB-GYN Nurse Practitioner',
    [SPECIALTY_IDS.ADULT_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER]:
        'Adult Psychiatric & Mental Health Nurse Practitioner',
    [SPECIALTY_IDS.FAMILY_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER]:
        'Family Psychiatric & Mental Health Nurse Practitioner',
    [SPECIALTY_IDS.MENTAL_HEALTH_NURSE_PRACTITIONER]:
        'Mental Health Nurse Practitioner',
    [SPECIALTY_IDS.UROLOGICAL_SURGEON]: 'Urological Surgeon',
    [SPECIALTY_IDS.OTOLOGIST]: 'Otologist',
    [SPECIALTY_IDS.FOOT_SURGEON]: 'Foot Surgeon',
    [SPECIALTY_IDS.HIP_SURGEON]: 'Hip Surgeon',
    [SPECIALTY_IDS.KNEE_SURGEON]: 'Knee Surgeon',
    [SPECIALTY_IDS.ELBOW_SURGEON]: 'Elbow Surgeon',
    [SPECIALTY_IDS.SHOULDER_SURGEON]: 'Shoulder Surgeon',
    [SPECIALTY_IDS.CHILD_AND_ADOLESCENT_PSYCHOLOGIST]:
        'Child and Adolescent Psychologist',
    [SPECIALTY_IDS.ENDOCRINE_SURGEON]: 'Endocrine Surgeon',
    [SPECIALTY_IDS.INTEGRATIVE_HEALTH_MEDICINE_SPECIALIST]:
        'Integrative Health Medicine Specialist',
    [SPECIALTY_IDS.BURN_SURGEON]: 'Burn Surgeon',
    [SPECIALTY_IDS.ADVANCED_HEART_FAILURE_AND_TRANSPLANT_CARDIOLOGIST]:
        'Advanced Heart Failure and Transplant Cardiologist',
    [SPECIALTY_IDS.PEDIATRIC_SLEEP_MEDICINE_SPECIALIST]:
        'Pediatric Sleep Medicine Specialist',
    [SPECIALTY_IDS.HOSPITALIST]: 'Hospitalist',
};

/**
 * @deprecated use @zocdoc-frontend-common/utils-constants instead
 * @type {Object.<string, string>}
 */
export const SPECIALTY_INSURANCE_TYPES = {
    [SPECIALTY_IDS.DENTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PRIMARY_CARE_PHYSICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.DERMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.EYE_DOCTOR]: INSURANCE_TYPES.VISION,
    [SPECIALTY_IDS.DENTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.INTERNIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.DERMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FAMILY_PHYSICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OB_GYN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CARDIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GASTROENTEROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEPHROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PULMONOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RHEUMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HEMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CARDIAC_ELECTROPHYSIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEUROSURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.INFECTIOUS_DISEASE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NUCLEAR_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OPHTHALMOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ORTHOPEDIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PLASTIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PODIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PSYCHIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RADIATION_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.UROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ENDOCRINOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEUROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SPORTS_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.EAR_NOSE_AND_THROAT_DOCTOR]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ALLERGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.COLORECTAL_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ENDODONTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.ORTHODONTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PERIODONTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PROSTHODONTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PAIN_MANAGEMENT_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.VASCULAR_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CARDIOTHORACIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HAND_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ANESTHESIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.EMERGENCY_MEDICINE_PHYSICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GENETICIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ORAL_SURGEON]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PEDIATRIC_DENTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PRIMARY_CARE_PHYSICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.IMMUNOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SLEEP_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CHIROPRACTOR]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OPTOMETRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MICROBIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.AESTHETIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CRANIOFACIAL_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HEAD_AND_NECK_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MICROVASCULAR_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FACIAL_PLASTIC_AND_RECONSTRUCTIVE_SURGEON]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEURO_OTOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SINUS_SURGEON_RHINOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_OTOLARYNGOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GERIATRICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OCULAR_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OCULAR_PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OPHTHALMIC_PLASTIC_ORBITAL_AND_RECONSTRUCTIVE_SURGEON]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OPHTHALMIC_PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEURO_OPHTHALMOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RETINA_SPECIALIST_MEDICAL]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RETINA_AND_VITREOUS_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CORNEA_AND_EXTERNAL_DISEASES_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_STRABISMUS_EYE_DOCTOR]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OCULOPLASTIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_ANESTHESIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEURO_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.LARYNGOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GLAUCOMA_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.UVEITIS_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.REFRACTIVE_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MATERNAL_FETAL_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GYNECOLOGIC_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.UROGYNECOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.BEHAVIORAL_PEDIATRICS_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_CARDIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_CRITICAL_CARE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_ENDOCRINOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_GASTROENTEROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_HEMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_INFECTIOUS_DISEASE_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_NEPHROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_PULMONOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CHILD_AND_ADOLESCENT_PSYCHIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEONATAL_PERINATAL_MEDICINE_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ADOLESCENT_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.BREAST_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.BARIATRIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.TRAUMA_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_NEUROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ULTRASOUND_SONOGRAPHY_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.INTERVENTIONAL_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ABDOMINAL_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.RECONSTRUCTIVE_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CARDIOTHORACIC_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CHEMICAL_PATHOLOGY_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CLINICAL_NEUROPHYSIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SKIN_PATHOLOGY_SPECIALIST_DERMATOPATHOLOGY]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.INTERVENTIONAL_NEURO_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CRITICAL_CARE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FOOT_AND_ANKLE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FORENSIC_PSYCHIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GERIATRIC_PSYCHIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MEDICAL_BIOCHEMICAL_GENETICIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MOLECULAR_GENETIC_PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MUSCULOSKELETAL_RADIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEUROMUSCULAR_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEUROPATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SPINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_SPORTS_MEDICINE_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PROCEDURAL_DERMATOLOGY_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ADDICTION_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PSYCHOSOMATIC_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.TRANSFUSION_MEDICINE_SPECIALIST_BLOOD_BANK]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CYTOPATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FORENSIC_PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_PATHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_ORTHOPEDIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CARDIOTHORACIC_ANESTHESIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.DEVELOPMENTAL_PEDIATRICS_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_UROLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MUSCOLOSKELETAL_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEURODEVELOPMENTAL_DISABILITIES_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.VASCULAR_NEUROLOGY_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_REHABILITATION_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.TOXICOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HYPERBARIC_TREATMENT_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.TRANSPLANT_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_TRANSPLANT_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.COSMETIC_DENTIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.DENTAL_PAIN_SPECIALIST]: INSURANCE_TYPES.DENTAL,
    [SPECIALTY_IDS.PHYSICAL_THERAPIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PHYSIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PSYCHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_DERMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.REPRODUCTIVE_ENDOCRINOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_NEUROSURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.TRAVEL_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PREVENTIVE_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ACUPUNCTURIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.AUDIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_ALLERGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_RHEUMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PSYCHOTHERAPIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SHOULDER_AND_ELBOW_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MEDICAL_ETHICIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.INTERVENTIONAL_CARDIOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OCCUPATIONAL_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.DIETITIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HEPATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MIDWIFE]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HIP_AND_KNEE_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.BARIATRIC_PHYSICIAN]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PROCTOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.COSMETIC_DERMATOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.GYNECOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HEART_FAILURE_HEART_TRANSPLANT_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HOSPICE_AND_PALLIATIVE_MEDICINE_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MASSAGE_THERAPIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MAXILLOFACIAL_PROSTHODONTIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NATUROPATHIC_DOCTOR]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OCCUPATIONAL_THERAPIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OPTOMETRIC_GLAUCOMA_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ORTHOPEDIC_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OSTEOPATHIC_DOCTOR]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_CARDIOTHORACIC_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_PAIN_MANAGEMENT_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PHYSICIAN_ASSISTANT]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.URGENT_CARE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NEUROPSYCHIATRIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NUTRITIONIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SURGICAL_ONCOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ADULT_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FAMILY_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.WOMENS_HEALTH_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OB_GYN_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ADULT_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FAMILY_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.MENTAL_HEALTH_NURSE_PRACTITIONER]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.UROLOGICAL_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.OTOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.FOOT_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HIP_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.KNEE_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ELBOW_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.SHOULDER_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.CHILD_AND_ADOLESCENT_PSYCHOLOGIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ENDOCRINE_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.INTEGRATIVE_HEALTH_MEDICINE_SPECIALIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.BURN_SURGEON]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.ADVANCED_HEART_FAILURE_AND_TRANSPLANT_CARDIOLOGIST]:
        INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.PEDIATRIC_SLEEP_MEDICINE_SPECIALIST]: INSURANCE_TYPES.HEALTH,
    [SPECIALTY_IDS.HOSPITALIST]: INSURANCE_TYPES.HEALTH,
};

/**
 * @deprecated use @zocdoc-frontend-common/utils-constants instead
 * @type {Object.<string, string>}
 */
export const DENTAL_INSURANCE_SPECIALTIES = new Set([
    SPECIALTY_IDS.COSMETIC_DENTIST,
    SPECIALTY_IDS.DENTAL_PAIN_SPECIALIST,
    SPECIALTY_IDS.DENTIST,
    SPECIALTY_IDS.ENDODONTIST,
    SPECIALTY_IDS.ORAL_SURGEON,
    SPECIALTY_IDS.ORTHODONTIST,
    SPECIALTY_IDS.PEDIATRIC_DENTIST,
    SPECIALTY_IDS.PERIODONTIST,
    SPECIALTY_IDS.PROSTHODONTIST,
]);

/**
 * @deprecated use @zocdoc-frontend-common/utils-constants instead
 * @type {Object.<string, string>}
 */
export const VISION_INSURANCE_SPECIALTIES = new Set([
    SPECIALTY_IDS.EYE_DOCTOR,
    SPECIALTY_IDS.OPHTHALMOLOGIST,
    SPECIALTY_IDS.OPTOMETRIST,
]);
